module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.songView.title))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box topic-box"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.songView.context)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box topic-box"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary text-center"
  }, [_vm._v(_vm._s(_vm.songView.author) + "經典片段")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link2
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link3
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote article-blockquote"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link4
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link5
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link6
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link7
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link8
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link9
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-mid-style"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "to": '/topic/'
    }
  }, [_vm._v("回婚禮主題表單")])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h4', {
    staticClass: "title text-primary text-center"
  }, [_vm._v(_vm._s(_vm.songView.author) + "歌單")]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.songView.lyric)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": 'https://www.weddingsung.com/songs/' + _vm.songView.id,
      "data-layout": "standard",
      "data-action": "like",
      "data-size": "small",
      "data-show-faces": "true",
      "data-share": "true"
    }
  }), _vm._v(" "), _c('Fbcomment', {
    attrs: {
      "videoId": _vm.songView.id
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2d5a520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TopicView.vue
// module id = 173
// module chunks = 1